import {
  PAYMENT_LIST_LOADING,
  GET_PAYMENT_LIST,
  GET_PAYMENT_LIST_ERROR,
  GET_PAYMENT_BY_ID_LOADING,
  GET_PAYMENT_BY_ID_SUCCESS,
  GET_PAYMENT_BY_ID_ERROR,
} from "./types";
import axios from "axios";
import { BASE_URL } from "../urls";

export const getList = (tokenData) => async (dispatch) => {
  dispatch({
    type: PAYMENT_LIST_LOADING,
  });
  await axios
    .get(`${BASE_URL}api/v1/admin/front/payment/admin`, {
      headers: {
        Authorization: `${tokenData.token_type} ${tokenData.access_token}`,
      },
    })
    .then(function (response) {
      dispatch({
        type: GET_PAYMENT_LIST,
        payload: response,
      });
    })
    .catch(function (error) {
      dispatch({
        type: GET_PAYMENT_LIST_ERROR,
        payload: error.response,
      });
    });
};

export const getEntityById = (tokenData, id) => async (dispatch) => {
  dispatch({
    type: GET_PAYMENT_BY_ID_LOADING,
  });
  await axios
    .get(`${BASE_URL}api/v1/admin/front/payment/single/${id}`, {
      headers: {
        Authorization: `${tokenData.token_type} ${tokenData.access_token}`,
      },
    })
    .then(function (response) {
      dispatch({
        type: GET_PAYMENT_BY_ID_SUCCESS,
        payload: response,
      });
    })
    .catch(function (error) {
      dispatch({
        type: GET_PAYMENT_BY_ID_ERROR,
        payload: error.response,
      });
    });
};
